import { render, staticRenderFns } from "./deliveryagentmaster_mr.vue?vue&type=template&id=cfb0211c&scoped=true"
import script from "./deliveryagentmaster_mr.vue?vue&type=script&lang=js"
export * from "./deliveryagentmaster_mr.vue?vue&type=script&lang=js"
import style0 from "./deliveryagentmaster_mr.vue?vue&type=style&index=0&id=cfb0211c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb0211c",
  null
  
)

export default component.exports